import Component from 'vue-class-component'

import './image-popup.scss'

import { ImageTransferHelper } from '@skinsoft/media-transfer-helper'
import { ReactiveVue } from '@skinsoft/reactive-vue'

@Component({
    template: require('./item-creation-image-popup.html'),
})
export class ItemCreationImagePopup extends ReactiveVue {
    public img = null
    private $imageTransferHelper: ImageTransferHelper

    public mounted() {
        this.open()
    }

    public imageChange(image) {
        const file = image.target.files[0]
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.addEventListener(
            'load',
            async () => {
                const media = { url: reader.result, file }
                if (media.url == null) {
                    media.url = ''
                } else if (media.url instanceof ArrayBuffer) {
                    media.url = media.url.toString()
                }
                const id = await this.$imageTransferHelper.uploadImage(
                    file.type,
                    file,
                    media.url,
                    false,
                    !window.navigator.onLine,
                )
                this.$emit('imageChoice', id)
            },
            false,
        )
    }

    public open() {
        ;(this.$refs.modal as any).show()
    }

    public loadImage() {
        ;(this.$refs.upload as any).click()
    }

    public close() {
        this.$emit('closePopup')
    }
}
